import { createRef } from 'react';

export const historyRef = createRef();
